export const EMPTY_SOLR_RESPONSE = { response: { numFound: 0, docs: [] } };

export const escapeSolrPhraseValue = (value) => {
    return String(value ?? '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"');
};

export const buildSolrPhraseFilter = (field, value) => {
    return `${field}:"${escapeSolrPhraseValue(value)}"`;
};
